<section class="sso-callback-wrapper">
  <div class="callback-card" *ngIf="isProcessing">
    <h1>Completing Sign-In</h1>
    <p>Please wait while we finalize your {{ provider || 'single sign-on' }} request.</p>
  </div>

  <div class="callback-card error" *ngIf="!isProcessing && errorMessage">
    <h1>We Couldn&apos;t Sign You In</h1>
    <p>{{ errorMessage }}</p>
    <button class="btn btn-primary" (click)="retry()">Return to Login</button>
  </div>
</section>
